import { IllegalArgumentsError } from "./error";
import { Point } from "./point";

/**
 * 幅と高さを保持します。
 *
 * @example
 * ```typescript
 *
 * const sizeA = new Size(10, 20);
 *
 * const sizeB = new Size(10, 10);
 * const sizeC = new Size(0, 10);
 *
 * console.assert(
 *   sizeA.equals(sizeB.append(sizeC)));
 * ```
 */
export class Size {
  public /*readonly*/ width: number;
  public /*readonly*/ height: number;

  constructor(orig: Size);
  constructor(width: number, height: number);

  constructor(arg1: Size | number, arg2?: number) {
    if (arg1 instanceof Size) {
      this.width = arg1.width;
      this.height = arg1.height;
    } else if (arg2 !== undefined) {
      this.width = arg1;
      this.height = arg2;
    } else {
      throw new IllegalArgumentsError(`${arg1}, ${arg2}`);
    }
  }

  public append(that: Size): Size {
    return {
      width: this.width + that.width,
      height: this.height + that.height,
    } as Size;
  }

  public subtract(that: Size): Size {
    return {
      width: this.width - that.width,
      height: this.height - that.height,
    } as Size;
  }

  public equals(that: Size): boolean {
    //return this.width === that.width && this.height === that.height;
    return (
      Math.abs(this.width - that.width) < Point.EPS &&
      Math.abs(this.height - that.height) < Point.EPS
    );
  }

  public round(): void /*Rectangle*/ {
    this.width = Math.round(this.width);
    this.height = Math.round(this.height);
  }

  public toString(): string {
    return `Size:[${this.width},${this.height}]`;
  }

  /**
   *
   */
  public get cx(): number {
    return this.width;
  }
  public get cy(): number {
    return this.height;
  }
}
